export default "__VITE_ASSET__Y1Kj8e2L__"